var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countries"},_vm._l((_vm.countries),function(country,index){return _c('div',{key:index,staticClass:"countries_item"},[_c('flag',{attrs:{"iso":country.alpha2}}),_vm._v(" "+_vm._s(country.name)+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }